import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/_services';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import * as FileSaver from 'file-saver';
import autoTable from 'jspdf-autotable'
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import { Form0WrpVO } from 'src/app/shared/models/Form0WrpVO';
import { first } from 'rxjs/operators';
import { ValuesVO } from 'src/app/shared/models/ValuesVO';
import { TovpilFilesService } from 'src/app/utils/tovpil-files.service';
import { DatePipe } from '@angular/common';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';

@Component({
  selector: 'app-workshop',
  templateUrl: './workshop.component.html',
  styleUrls: ['./workshop.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class WorkshopComponent implements OnInit {

  currentUser: any;

  token: string;

  device: string;

  security: SecurityDocument;

  workShopDialog: boolean;

  lstWorkShops: any[];

  workshop: any;

  selectedProducts: any[];

  submitted: boolean;

  isDisabled: boolean;

  displayModalStatus: boolean;
  commentsSelected: string;
  dateSelected: string;
  statusSelected: ValuesVO;
  statusList: ValuesVO[];
  SchoolTranStsList: ValuesVO[];
  blocked: boolean = true;

  lbl_id: string = "id_";
  lbl_go_Back: string = "back_";
  lbl_my_workshops: string = "my_workshops_";
  lbl_new_record: string = "new_record_";
  lbl_period: string = "period_";
  lbl_church: string = "churchs_";
  lbl_service: string = "service_";
  lbl_status: string = "status_";
  lbl_date: string = "date_";
  lbl_time: string = "time_";
  lbl_search: string = "search_";
  lbl_attendance: string = "attendance_";
  lbl_sign_up: string = "sign_up_";
  lbl_edit: string = "edit_";
  lbl_delete: string = "delete_record_";
  lbl_select: string = "select_";
  lbl_option: string = "option_";
  lbl_workshop: string = "wokshop_";
  lbl_Secretary_can_add_more_partici: string = "Secretary_can_add_more_partici";
  lbl_comments: string = "comments_";
  lbl_save: string = "save_";
  lbl_showing: string = "showing_";
  lbl_of: string = "of_";
  lbl_records: string = "records_";
  lbl_total: string = "total_";
  lbl_services: string = "services_";
  lbl_are_you_sure: string = "are_you_sure_";
  lbl_confirm: string = "confirm_";
  lbl_loading: string = "loading_";






  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private filesService: TovpilFilesService,
    private tovpilUtils: TovpilUtilsService) {
    this.route.queryParams.subscribe(
      params => {
        this.token = params.token;
        this.device = params.device;
      });

    if (this.token) {
      if (this.device && this.device == "2") {
        this.autenthicateByZuul('generalaccess', 'hY6Mn_4hn9vDrWrh6');
      }
    } else {
      this.currentUser = this.authenticationService.currentUserValue;
      this.getSecurity(this.currentUser.tokenProfile);

    }

  }

  ngOnInit(): void {

  }

  hideDialog() {
    this.workShopDialog = false;
    this.submitted = false;
  }

  openNew() {

    this.workshop = {};
    this.openWorkShopDetail(null);

  }

  saveProduct() {
    this.submitted = true;


  }


  openWorkShopDetail(workshopSel: any) {
    let obj = {
      workshop: workshopSel,
      security: this.security,
      type: 'W'
    }

    let queryParamsDetail = {}

    if (this.token && this.device) {

      queryParamsDetail = {
        token: this.token,
        device: this.device
      }
    }

    let navigationExtras: NavigationExtras = {
      queryParams: queryParamsDetail,
      state: JSON.parse(JSON.stringify(obj))
    }

    this.router.navigate(
      ['/guide/workshopsDetail'], navigationExtras);
  }

  openWorkShopParticipant(workshopSel: any) {
    let obj = {
      workshop: workshopSel,
      security: this.security
    }

    let queryParamsDetail = {}

    if (this.token && this.device) {
      queryParamsDetail = {
        token: this.token,
        device: this.device
      }
    }

    let navigationExtras: NavigationExtras = {
      queryParams: queryParamsDetail,
      state: JSON.parse(JSON.stringify(obj))
    }
    this.router.navigate(['guide/workshopsParticipant'], navigationExtras);
  }

  openWorkShopAssistance(workshopSel: any) {
    let obj = {
      workshop: workshopSel,
      security: this.security
    }
    let queryParamsDetail = {}

    if (this.token && this.device) {

      queryParamsDetail = {
        token: this.token,
        device: this.device
      }
    }

    let navigationExtras: NavigationExtras = {
      queryParams: queryParamsDetail,
      state: JSON.parse(JSON.stringify(obj))
    }

    if (workshopSel.f0.serTyp == '16' || workshopSel.f0.serTyp == '17' || workshopSel.f0.serTyp == '18') {
      //Check if service has a school.
      this.router.navigate(['secretary/schoolAssistance'], navigationExtras);
      // else do next

    } else {
      this.router.navigate(['guide/workshopAssistance'], navigationExtras);
    }
  }

  getSecurity(tokenProfile: string) {
    this.apiService.findSecurityById({ "id": tokenProfile }).then(
      data => {
        this.security = data;
        this.getTranslatedLabels();
        this.geWorkShopsGuide();
        if (this.security && this.security.levelId == 'F') {
          this.isDisabled = true;
        }
        else {
          this.isDisabled = false;
        }
      });
  }

  geWorkShopsGuide() {
    this.blocked = true;
    this.apiService.findWorkShopsByGuideId({ "guideId": this.security.guideId }).then(
      data => {
        this.lstWorkShops = data.filter(e => this.checkStatus(e));
        this.blocked = false;
      }).then()
      .finally(() => {
        setTimeout(() => {
          this.blocked = false;
        }, 1500);
      });;

  }

  datePipe: DatePipe = new DatePipe('en-US');
  /**
   * This function formats a given date string into a specific format using the datePipe module in
   * TypeScript.
   * @param {string} dateString - A string representing a date in any valid format (e.g. "2021-10-15" or
   * "Oct 15, 2021").
   * @returns The function `formatDate` is returning a formatted date string in the format of
   * 'dd-MM-yyyy'. The input parameter `dateString` is being passed to the `datePipe.transform` method to
   * format the date. The formatted date string is then returned by the function.
   */
  formatDate(dateString: string) {

    const formattedDate = this.datePipe.transform(this.tovpilUtils.convertStringToDate(dateString), 'yyyy-MM-dd');
    return formattedDate;
  }

  exportExcel() {
    if (this.lstWorkShops === null) {
      this.messageService.add({
        severity: 'error',
        summary: 'No existe información para procesar',
        life: 3000
      });
    } else if (this.lstWorkShops.length < 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'La lista está vacía',
        life: 3000
      });
    } else {
      const filteredJSON = this.lstWorkShops.map((item) => {
        return {
          "AÑO": item.f0 ? (item.f0.anio || 'S/N') : 'S/N',
          "NOMBRE": item.chr ? (item.chr.name || 'S/N') : 'S/N',
          "SERVICIO": item.wst ? (item.wst.wsName || 'S/N') : 'S/N',
          "FECHA_INICIO": item.f0 ? (this.formatDate(item.f0.strDate) || '0') : '0',
          "FECHA_TERMINO": item.f0 ? (this.formatDate(item.f0.fromTime) || '0') : '0',
          "ESTATUS": item.wrkStatName || 'S/N',
        };
      });


      this.filesService.tovpilExportXLSX(filteredJSON, 'listServices_');

    }
  }



  exportPdf() {
    if (this.lstWorkShops === null) {
      this.messageService.add({
        severity: 'error',
        summary: 'No existe información para procesar',
        life: 3000
      });
    } else if (this.lstWorkShops.length < 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'La lista está vacía',
        life: 3000
      });
    } else {
      const filteredJSON = this.lstWorkShops.map((item) => {
        return {
          "AÑO": item.f0 ? (item.f0.anio || 'S/N') : 'S/N',
          "NOMBRE": item.chr ? (item.chr.name || 'S/N') : 'S/N',
          "SERVICIO": item.wst ? (item.wst.wsName || 'S/N') : 'S/N',
          "FECHA_INICIO": item.f0 ? (this.formatDate(item.f0.strDate) || '0') : '0',
          "FECHA_TERMINO": item.f0 ? (this.formatDate(item.f0.fromTime) || '0') : '0',
          "ESTATUS": item.wrkStatName || 'S/N',
        };
      });
      const keysArray = filteredJSON.map((item) => Object.keys(item));
      const valuesArray = filteredJSON.map((item) => Object.values(item));

      this.filesService.tovpilExportPDF(keysArray[0], valuesArray, 'listServices_');

    }
  }


  deleteWorkShop(workshop: any) {
    this.confirmationService.confirm({
      message: '¿ ' + this.lbl_are_you_sure + ' ' + this.lbl_delete + ' ?',
      header: this.lbl_confirm + ' ' + this.lbl_delete + ' ' + this.lbl_workshop,
      icon: 'pi pi-exclamation-triangle',
      acceptButtonStyleClass: "p-button-danger",
      rejectButtonStyleClass: "p-button-info",
      accept: () => {
        this.deleteWorkShopService(workshop);
      }
    });
  }


  deleteWorkShopService(workshopSelected: any) {

    let form0: Form0WrpVO = {
      form0: {
        wrksId: workshopSelected.f0.wrksId,
        cancelSts: 'X'
      },
      language: this.security.language
    }

    this.apiService.createUpdateCancelForm0Wrp(form0).then(
      data => {

        if (data && data.status.trim() == 'OK') {
          this.messageService.add({ severity: 'success', summary: 'Creación', detail: "Se canceló " + this.lbl_workshop + " correctamente", life: 3000 });
          this.geWorkShopsGuide();
        } else {
          this.messageService.add({ severity: 'error', summary: 'ERROR: ' + data.errorMessage, detail: " ", life: 10000 });
        }

      }).catch(error => {
        console.error(error);
        this.messageService.add({ severity: 'error', summary: 'Creación', detail: "Error al eliminar " + this.lbl_workshop, life: 3000 });
      });


  }
  getTranslatedLabels() {
    let map = new Map();
    let lstRespTranslate: TranslateRelLabelVO[];
    this.blocked = true;
    this.apiService.listByLanguageMultFields({
      'language': this.security.language,
      'region': this.security.region,
      'lstLabels': [this.lbl_id, this.lbl_go_Back, this.lbl_my_workshops, this.lbl_new_record, this.lbl_period, this.lbl_church, this.lbl_service, this.lbl_date, this.lbl_time, this.lbl_search, this.lbl_attendance, this.lbl_sign_up, this.lbl_edit, this.lbl_delete, this.lbl_Secretary_can_add_more_partici, this.lbl_select, this.lbl_option, this.lbl_workshop, this.lbl_status, this.lbl_comments, this.lbl_save, this.lbl_showing, this.lbl_of, this.lbl_records, this.lbl_total, this.lbl_services, this.lbl_are_you_sure, this.lbl_confirm, this.lbl_loading]
    }).then(
      trDocs => {
        this.blocked = false;

        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });

        this.lbl_id = map.get(this.lbl_id).toUpperCase();
        this.lbl_go_Back = map.get(this.lbl_go_Back);
        this.lbl_my_workshops = map.get(this.lbl_my_workshops);
        this.lbl_new_record = map.get(this.lbl_new_record);
        this.lbl_period = map.get(this.lbl_period);
        this.lbl_church = map.get(this.lbl_church);
        this.lbl_service = map.get(this.lbl_service);
        this.lbl_date = map.get(this.lbl_date);
        this.lbl_time = map.get(this.lbl_time);
        this.lbl_search = map.get(this.lbl_search);
        this.lbl_attendance = map.get(this.lbl_attendance);
        this.lbl_edit = map.get(this.lbl_edit);
        this.lbl_delete = map.get(this.lbl_delete);
        this.lbl_select = map.get(this.lbl_select);
        this.lbl_sign_up = map.get(this.lbl_sign_up);
        this.lbl_option = map.get(this.lbl_option);
        this.lbl_workshop = map.get(this.lbl_workshop);
        this.lbl_status = map.get(this.lbl_status);
        this.lbl_comments = map.get(this.lbl_comments);
        this.lbl_save = map.get(this.lbl_save);
        this.lbl_showing = map.get(this.lbl_showing);
        this.lbl_of = map.get(this.lbl_of);
        this.lbl_records = map.get(this.lbl_records);
        this.lbl_total = map.get(this.lbl_total);
        this.lbl_services = map.get(this.lbl_services);
        this.lbl_are_you_sure = map.get(this.lbl_are_you_sure);
        this.lbl_confirm = map.get(this.lbl_confirm);
        this.lbl_loading = map.get(this.lbl_loading);

        this.lbl_Secretary_can_add_more_partici = map.get(this.lbl_Secretary_can_add_more_partici);
      });
  }
  goBack() {
    window.close();
  }

  autenthicateByZuul(user: string, password: string) {
    this.authenticationService.login(user, password)
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 'R-0200') {
            this.getSecurity(this.token);
          } else {
          }
        },
        error => {
        });
  }
  showDialogStatus(workShopSel: any) {
    this.commentsSelected = null;
    this.dateSelected = null;
    this.statusSelected = null;
    this.workshop = workShopSel;
    this.getStatusTransitionRules();
    this.displayModalStatus = true;
  }
  getStatusTransitionRules() {
    this.apiService.getStatusTransitionRules({
      "language": this.security.language,
      "fieldId": "plwStatus",
      "fieldVal": this.workshop.status
    }).then(
      data => {
        this.SchoolTranStsList = data;
      });
  }

  checkStatus(workshop: any): boolean {
    try {
      const statusNumber = parseInt(workshop.wrkStatName.split(' ')[0], 10);
      if (isNaN(statusNumber)) {
        console.error('Error: No se pudo convertir a número el estado:', workshop.wrkStatName);
        return true;
      }
      return statusNumber < 5;  // Mostrar solo si es menor a 5
    } catch (error) {
      console.error('Error al procesar el estado:', error);
      return true;
    }
  }

}
